export const textModalKey = 'textModalOpen'
export const videoModalKey = 'videoModalOpen'
export const compareDemographicsModalKey = 'compareDemographicsOpen'
export const videoButtonsModalKey = 'videoButtonsModalKey'
